export default __webpack_public_path__ + "static/viinitie-banner-wedding-desktop-narrow.319ff67186cb796cd485f179edb3fc2e.jpg";